module.exports = __webpack_public_path__ + "static/picture-1-ed06cda517c12ba3b076455fbbd1be28.png";